export enum ValidationMessages {
  required = "Required.",
  positiveNumber = "Please enter a number greater than 0",
  email = "Please enter a valid email.",
  ipRange = "Please enter a valid IP range.",
  guid = "Does not match GUID pattern.",
  ipStartLessThenOrEqualToEnd = "Start IP must be less than or equal to End IP."
}
